"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var immer_1 = require("immer");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var message_1 = require("./message");
function createPropsForForges(store, selectorFunction) {
    var subState$ = new rxjs_1.BehaviorSubject(selectorFunction(store.state));
    var state = function () { return selectorFunction(store.state); };
    var subscription = store.state$
        .pipe(operators_1.map(function (statePackage) { return statePackage.state; }), operators_1.map(selectorFunction), operators_1.distinctUntilChanged())
        .subscribe(function (nextValue) { return subState$.next(nextValue); });
    function next(updateFunction, message) {
        if (message === void 0) { message = message_1.RESTATE_UPDATE_MESSAGE; }
        var currentState = store.state;
        var draftState = immer_1.createDraft(currentState);
        var subState = selectorFunction(draftState);
        updateFunction(subState);
        var patchListener = function (_patches, _inversePatches) { };
        var nextState = immer_1.finishDraft(draftState, patchListener);
        store.next(nextState, message);
    }
    function dispatch(msg) {
        store.dispatch(msg);
    }
    return {
        next: next,
        state: state,
        dispatch: dispatch,
        store: store,
        subscription: subscription
    };
}
function connectActions(store, selectorFunction, actionFactory) {
    var props = createPropsForForges(store, selectorFunction);
    return actionFactory(props);
}
exports.connectActions = connectActions;
//# sourceMappingURL=connect-actions.js.map